import { taskApiClient } from '@/utils/apiClient';

/**
 * Auth service — task management user listing via gateway
 */
export const getAllUsers = async () => {
  const res = await taskApiClient.get('/auth/users');
  return res.data;
};
